export const workflowConfig = {
  nodeWidth: 150,
  nodeHeight: 40,
  groupPadding: 20,
  defaultNodesXMargin: 20,
  defaultNodesYMargin: 60,
};
